import * as React from 'react'

import {
  ClosingReqCheck,
  ClosingRequirementLink,
  ClosingRequirementButton,
  type ClosingRequirementButtonProps,
} from './atoms'
import { useClosingReqContext } from '../context'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'

type Props = {
  count: number
  countLoading?: boolean

  linkText: string
  linkClick?: () => void

  title: string
  icon: JSX.Element
  isComplete: boolean
} & ClosingRequirementButtonProps

export function ClosingRequirement(props: Props) {
  const {
    count,
    countLoading = false,
    icon,
    isComplete,
    title,
    linkClick,
    entityId,
    linkText,
    requirement,
  } = props

  const linkDisabled = count === 0 || countLoading

  const [{ activeRequirement }] = useClosingReqContext()

  const isActive = activeRequirement === requirement

  return (
    <Paper elevation={2}>
      <Stack
        p={1.4}
        height="153px"
        minWidth="193px"
        alignItems="center"
        position="relative"
        justifyContent="flex-end"
      >
        <Stack direction="row" alignItems="center" height="100%" mb={1.5}>
          {icon}
          <Typography
            ml={1}
            fontSize="16px"
            lineHeight="150%"
            letterSpacing="0.15px"
            fontFamily="Source Sans Pro SemiBold"
          >
            {title}
          </Typography>
        </Stack>

        <ClosingRequirementButton {...props} />

        <Stack direction="row" alignItems="center" mt={1.2}>
          <ClosingReqCheck isComplete={isComplete} />

          <ClosingRequirementLink
            count={count}
            linkText={linkText}
            linkClick={linkClick}
            disabled={linkDisabled}
            requirement={requirement}
            countLoading={countLoading}
            testId={`${requirement}Link-${entityId}`}
          />
        </Stack>

        <Fade in={isActive}>
          <Box
            bottom={0}
            height={3}
            width="100%"
            position="absolute"
            bgcolor="primary.main"
            borderRadius="0 0 4px 4px"
          />
        </Fade>
      </Stack>
    </Paper>
  )
}
